import { useContext, useState } from 'react';

import { observer } from 'mobx-react-lite';

import { RootStoreContext } from 'index';
import SideBar from 'components/common/SideBar/SideBar';

import styles from './AccountSettings.module.scss';
import mainStyles from '../MyProfile.module.scss';
import UpdatePassword from './UpdatePassword/UpdatePassword';
import UpdateAccountEmail from './UpdateAccountEmail/UpdateAccountEmail';

const AccountSettings = () => {
  const { authStore } = useContext(RootStoreContext);

  const [isOpenChangePasswordSidebar, setOpenChangePasswordSidebar] = useState(false);
  const [isOpenChangeEmailSidebar, setOpenChangeEmailSidebar] = useState(false);

  const handleClickOpenChangePasswordSidebar = () => {
    setOpenChangePasswordSidebar(true);
  };

  const handleCloseOpenChangePasswordSidebar = () => {
    setOpenChangePasswordSidebar(false);
  };

  const handleClickOpenChangeEmailSidebar = () => {
    setOpenChangeEmailSidebar(true);
  };

  const handleCloseOpenChangeEmailSidebar = () => {
    setOpenChangeEmailSidebar(false);
  };

  return (
    <div className={mainStyles.mainContainer}>
      <div className={mainStyles.inputsContainer}>
        <div className={mainStyles.header}>
          <h3 className={mainStyles.headerLabel}>Account Settings</h3>
        </div>
        <div className={styles.accountSettingBox}>
          <p className={styles.accountSettingTitle}>Email Address</p>
          <div>
            <p>{authStore.account?.email}</p>
            <p className={styles.accountActionButton} onClick={handleClickOpenChangeEmailSidebar}>
              Change Email Address
            </p>
            <SideBar title="Change Email" isOpen={isOpenChangeEmailSidebar} onClose={handleCloseOpenChangeEmailSidebar}>
              <UpdateAccountEmail onClose={handleCloseOpenChangeEmailSidebar} />
            </SideBar>
          </div>
        </div>
        <div className={styles.accountSettingBox}>
          <p className={styles.accountSettingTitle}>Password</p>
          <div>
            <p>••••••••••••••</p>
            <p className={styles.accountActionButton} onClick={handleClickOpenChangePasswordSidebar}>
              Change Password
            </p>
            <SideBar
              title="Change Password"
              isOpen={isOpenChangePasswordSidebar}
              onClose={handleCloseOpenChangePasswordSidebar}
            >
              <UpdatePassword onClose={handleCloseOpenChangePasswordSidebar} />
            </SideBar>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(AccountSettings);
